export default {
  aboutservice: {
    subtitle: "// ORDER SMARTER, SPEND LESS FOR",

    title: "Restaurants",

    desc:
      "Buy smarter and operate better. Communicate with suppliers, place and track orders, explore an all-in-one marketplace, and generate LPOs with ease — all inside the Mahal platform. One system. Total control.",

    text:
      "Order smarter, spend less. Chat with suppliers, place and track every order, explore a full marketplace, and generate LPOs — all in one unified Mahal platform. Efficiency that truly feels effortless.",

    cta: "Restaurant Portal",

    
  },
};